import { render, staticRenderFns } from "./WorkStatusOnboarding.vue?vue&type=template&id=ae41f708"
import script from "./WorkStatusOnboarding.vue?vue&type=script&setup=true&lang=ts"
export * from "./WorkStatusOnboarding.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ae41f708')) {
      api.createRecord('ae41f708', component.options)
    } else {
      api.reload('ae41f708', component.options)
    }
    module.hot.accept("./WorkStatusOnboarding.vue?vue&type=template&id=ae41f708", function () {
      api.rerender('ae41f708', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/organisms/WorkStatusOnboarding.vue"
export default component.exports